export default __webpack_public_path__ + "static/media/4.493b4ee3.jpg";